import { useMemo } from 'react';
import { LOG_SCALE_AXIS_NEAR_ZERO_NUMBER } from '@/components';
import { TimeSeriesDataset } from '@/core';

export const correctDataForLogAxis = (datasets: TimeSeriesDataset[], indicesToCorrect = [] as number[]) => {
  for (const index of indicesToCorrect) {
    const dataset = datasets[index];

    if (dataset) {
      for (let i = 0; i < dataset.source.length; i++) {
        const source = dataset.source[i];

        if (source?.[1] === 0) {
          source[1] = LOG_SCALE_AXIS_NEAR_ZERO_NUMBER;
        }
      }
    }
  }
};

export const useCorrectDataForLogAxis = (datasets: TimeSeriesDataset[], indicesToCorrect = [] as number[]) => {
  return useMemo(() => {
    correctDataForLogAxis(datasets, indicesToCorrect);
  }, [datasets, indicesToCorrect]);
};
